import React, { useState, useEffect, useRef, useMemo } from "react";
import '../../pages/Pdv/style.css';
import '../../pages/Pdv/styleResponsive.css';
import '../../pages/Pdv/modernStyle.css';
import '../../pages/Pdv/styleModern.css';
import styled, { keyframes, css } from 'styled-components';
import PhoneInput from '../PhoneInput';
import { toE164, fromE164, localDigitsFromE164, formatPhoneDisplay } from '../../utils/phone';
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { getStoredUser } from '../../utils/safeStorage';
import { HiChevronDoubleRight } from 'react-icons/hi';
// import { AuthContext } from "../../contexts/auth"; // Não utilizado atualmente
// import { SidebarContext } from "../../AppRoutes"; // Não utilizado atualmente
import { updatePedidoFromPdv, updatePedidoFromMesas, getCategorias, getItens, getVinculoEmpresa, getAdicionaisCardapio, getCliente, getClienteByName, registerClienteFromCardapio } from "../../services/api";
// import { useNavigate } from "react-router-dom"; // Não utilizado atualmente
import { saveToLocalStorage, removeFromLocalStorage } from '../../utils/localStorage';
// import LeftMenu from "../../components/LeftMenu"; // Não utilizado atualmente
import PermissionGate from "../../services/PermissionGate";
import ModalAdicionais from "../../pages/Pdv/ModalAdicionais";
// import { FaFilter } from "react-icons/fa"; // Não utilizado atualmente
// import { AiOutlineArrowRight } from "react-icons/ai"; // Não utilizado atualmente
// import { IoMdExit } from "react-icons/io"; // Não utilizado atualmente
import { MdFastfood } from "react-icons/md";
import SafeImage from "../SafeImage";
import { MdShoppingCartCheckout } from "react-icons/md";
import ModalAddObsPedido from "../../pages/Pdv/ModalAddObsPedido";
import ModalAddObsItem from "../../pages/Pdv/ModalAddObsItem";
import ModalEntregaPdv from "../../pages/Pdv/ModalEntregaPdv";
// import AsyncSelect from 'react-select/async'; // Não utilizado atualmente
import Loading from "react-loading";
// import { calc } from "antd/es/theme/internal"; // Não utilizado atualmente
// import { IoIosArrowBack } from "react-icons/io"; // Não utilizado atualmente
import ModalPagamentos from "../../pages/Pdv/ModalPagamentos";
import ModalCpfCnpj from "../../pages/Pdv/ModalCpfCnpj";
import ModalDesconto from "../../pages/Pdv/ModalDesconto";
import { formatPriceWithSymbol } from "../../utils/currency";
// import { set } from "react-hook-form"; // Não utilizado atualmente

// Animações de slide
const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

// Wrapper externo para permitir o botão de colapsar ficar fora do container
const ModalWrapper = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    width: 65vw;
    max-width: 1200px;
    height: 100vh;
    z-index: 99;
    pointer-events: none;

    /* Animação de entrada/saída */
    ${({ showModal, isClosing }) => {
        if (!showModal && !isClosing) return css`display: none;`;
        if (isClosing) return css`
            display: block;
            animation: ${slideOut} 0.35s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        `;
        return css`
            display: block;
            animation: ${slideIn} 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        `;
    }}

    @media (max-width: 768px) {
        width: 95vw;
        max-width: none;
    }

    @media (max-width: 480px) {
        width: 100vw;
    }
`;

const Teste = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: #f8fafc;
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    pointer-events: auto;

    /* Borda decorativa à esquerda */
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: linear-gradient(180deg, #318CD5 0%, #4facfe 50%, #318CD5 100%);
        z-index: 10;
    }
`;

// Botão de colapsar com seta >> (posicionado no wrapper para ficar visível)
const CollapseButton = styled.button`
    position: absolute;
    top: 20px;
    left: -52px;
    width: 52px;
    height: 52px;
    background: linear-gradient(135deg, #318CD5 0%, #4facfe 100%);
    border: none;
    border-radius: 14px 0 0 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 26px;
    box-shadow: -4px 4px 20px rgba(49, 140, 213, 0.35);
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 101;
    pointer-events: auto;

    &:hover {
        background: linear-gradient(135deg, #2678b8 0%, #3d9ae6 100%);
        transform: translateX(-6px);
        box-shadow: -8px 4px 24px rgba(49, 140, 213, 0.45);
    }

    &:active {
        transform: translateX(-3px) scale(0.97);
    }

    svg {
        transition: transform 0.2s ease;
    }

    &:hover svg {
        transform: translateX(3px);
    }

    @media (max-height: 800px) {
        width: 40px;
        height: 40px;
        left: -40px;
        font-size: 20px;
        border-radius: 10px 0 0 10px;
        top: 14px;
    }

    @media (max-width: 768px) {
        left: -48px;
        width: 48px;
        height: 48px;
        font-size: 22px;
        border-radius: 12px 0 0 12px;
    }
`;

// Layout principal moderno
const ModernLayout = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    overflow: hidden;

    @media (max-width: 900px) {
        flex-direction: column;
        overflow-y: auto;
    }
`;

// Seção do menu (esquerda)
const MenuSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    background: white;
    border-right: 1px solid #e5e7eb;
    overflow: hidden;

    @media (max-width: 900px) {
        border-right: none;
        border-bottom: 1px solid #e5e7eb;
        min-height: 50vh;
        overflow: visible;
    }
`;

// Header do menu
const MenuHeader = styled.div`
    padding: 20px 24px;
    background: white;
    border-bottom: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;

    @media (max-height: 800px) {
        padding: 8px 14px;
    }

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        padding: 16px;
    }
`;

const HeaderTitle = styled.div`
    h2 {
        margin: 0;
        font-size: 22px;
        font-weight: 700;
        color: #1e293b;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    p {
        margin: 4px 0 0;
        font-size: 13px;
        color: #64748b;
    }

    @media (max-height: 800px) {
        h2 { font-size: 16px; gap: 6px; }
        p { font-size: 11px; margin-top: 2px; }
    }

    @media (max-width: 600px) {
        h2 {
            font-size: 17px;
            gap: 8px;
        }
    }
`;

const SendToCartBtn = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #318CD5 0%, #4facfe 100%);
    color: white;
    border: none;
    border-radius: 10px;
    padding: 12px 20px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(49, 140, 213, 0.25);
    white-space: nowrap;
    flex-shrink: 0;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(49, 140, 213, 0.35);
    }

    svg {
        font-size: 18px;
    }

    @media (max-height: 800px) {
        padding: 6px 14px;
        font-size: 12px;
        border-radius: 8px;
        svg { font-size: 15px; }
    }

    @media (max-width: 600px) {
        padding: 10px 16px;
        font-size: 13px;
        width: 100%;
        justify-content: center;
    }
`;

// Conteúdo do menu com categorias e itens
const MenuContent = styled.div`
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;

    @media (max-width: 700px) {
        flex-direction: column;
    }
`;

// Sidebar de categorias
const CategoriesSidebar = styled.div`
    width: 180px;
    background: #f8fafc;
    border-right: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    h3 {
        margin: 0;
        padding: 16px;
        font-size: 14px;
        font-weight: 600;
        color: #475569;
        border-bottom: 1px solid #e5e7eb;
    }

    @media (max-height: 800px) {
        width: 150px;
        h3 { padding: 8px 10px; font-size: 12px; }
    }

    @media (max-width: 700px) {
        width: 100%;
        border-right: none;
        border-bottom: 1px solid #e5e7eb;
        max-height: 140px;

        h3 {
            padding: 10px 16px;
            font-size: 13px;
        }
    }
`;

const CategoriesList = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    @media (max-width: 700px) {
        flex-direction: row;
        overflow-x: auto;
        overflow-y: hidden;
        flex-wrap: nowrap;
        padding: 8px 12px;
        gap: 6px;
        -webkit-overflow-scrolling: touch;
    }
`;

const CategoryBtn = styled.button`
    display: flex;
    align-items: center;
    background: ${({ active }) => active ? 'linear-gradient(135deg, #318CD5 0%, #4facfe 100%)' : 'white'};
    color: ${({ active }) => active ? 'white' : '#475569'};
    border: 1px solid ${({ active }) => active ? 'transparent' : '#e5e7eb'};
    padding: 10px 14px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;
    width: 100%;
    font-size: 13px;
    font-weight: 600;
    box-shadow: ${({ active }) => active ? '0 2px 8px rgba(49, 140, 213, 0.25)' : '0 1px 2px rgba(0, 0, 0, 0.05)'};

    &:hover {
        background: ${({ active }) => active ? 'linear-gradient(135deg, #2678b8 0%, #3d9ae6 100%)' : '#f1f5f9'};
        transform: translateX(2px);
    }

    @media (max-width: 700px) {
        white-space: nowrap;
        flex-shrink: 0;
        width: auto;
        padding: 8px 14px;
        font-size: 12px;

        &:hover {
            transform: none;
        }
    }
`;

// Container de itens
const ItemsContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 12px;

    @media (max-width: 600px) {
        padding: 10px;
    }
`;

const CategorySection = styled.div`
    margin-bottom: 28px;
`;

const CategoryHeader = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;

    h4 {
        margin: 0;
        font-size: 14px;
        font-weight: 700;
        color: #1e293b;
    }

    &::after {
        content: '';
        flex: 1;
        height: 2px;
        background: linear-gradient(to right, #318CD5, transparent);
    }
`;

const ItemsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;

    @media (max-height: 800px) {
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
        gap: 8px;
    }

    @media (max-width: 600px) {
        grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
        gap: 10px;
    }
`;

const ItemCard = styled.div`
    background: white;
    border: 2px solid ${({ selected }) => selected ? '#318CD5' : '#e5e7eb'};
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: ${({ selected }) => selected ? '0 4px 12px rgba(49, 140, 213, 0.2)' : '0 1px 3px rgba(0, 0, 0, 0.05)'};

    &:hover {
        border-color: #318CD5;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(49, 140, 213, 0.15);
    }
`;

const ItemImage = styled.div`
    width: 100%;
    height: 80px;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    svg {
        font-size: 48px;
        color: #94a3b8;
    }
`;

const ItemInfo = styled.div`
    padding: 8px;

    h5 {
        margin: 0 0 4px;
        font-size: 11px;
        font-weight: 600;
        color: #1e293b;
        line-height: 1.3;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .price {
        font-size: 12px;
        font-weight: 700;
        color: #318CD5;
    }
`;

const ItemQuantity = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    margin-top: 8px;
    background: #f8fafc;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #e5e7eb;

    button {
        width: 32px;
        height: 32px;
        border: none;
        background: transparent;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #475569;
        transition: all 0.15s ease;

        &:hover {
            background: #e2e8f0;
            color: #318CD5;
        }
    }

    input {
        width: 40px;
        height: 32px;
        border: none;
        border-left: 1px solid #e5e7eb;
        border-right: 1px solid #e5e7eb;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: #1e293b;
        background: white;
    }
`;

// Seção do carrinho (direita)
const CartSection = styled.div`
    width: 400px;
    min-width: 380px;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    background: white;
    overflow: hidden;

    @media (max-width: 1200px) {
        width: 360px;
        min-width: 340px;
    }

    @media (max-width: 900px) {
        width: 100%;
        min-width: unset;
        max-width: unset;
        min-height: 300px;
    }
`;

const CartHeader = styled.div`
    padding: 16px 20px;
    background: #f8fafc;
    border-bottom: 1px solid #e5e7eb;
    flex-shrink: 0;

    @media (max-height: 800px) {
        padding: 6px 12px;
    }
`;

const CartTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 700;
        color: #1e293b;
    }

    @media (max-height: 800px) {
        margin-bottom: 6px;
        h3 { font-size: 13px; }
    }
`;

const CartActions = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

const ActionBtn = styled.button`
    padding: 6px 12px;
    border-radius: 8px;
    border: 1.5px solid ${({ variant }) =>
        variant === 'primary' ? '#318CD5' :
        variant === 'danger' ? '#ef4444' : '#d1d5db'};
    background: ${({ variant, active }) =>
        active ? (variant === 'primary' ? '#318CD5' : variant === 'danger' ? '#ef4444' : '#f1f5f9') :
        'white'};
    color: ${({ variant, active }) =>
        active ? 'white' :
        variant === 'primary' ? '#318CD5' :
        variant === 'danger' ? '#ef4444' : '#475569'};
    font-size: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    text-transform: uppercase;
    letter-spacing: 0.025em;

    &:hover {
        background: ${({ variant }) =>
            variant === 'primary' ? '#318CD5' :
            variant === 'danger' ? '#ef4444' : '#f1f5f9'};
        color: ${({ variant }) =>
            variant === 'danger' || variant === 'primary' ? 'white' : '#1e293b'};
    }
`;

// Lista de itens do carrinho com scroll
const CartItems = styled.div`
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
`;

const EmptyCart = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 20px 16px;
    text-align: center;
    color: #94a3b8;

    svg {
        font-size: 40px;
        margin-bottom: 8px;
        color: #cbd5e1;
    }

    h4 {
        margin: 0 0 4px;
        font-size: 14px;
        font-weight: 600;
        color: #64748b;
    }

    p {
        margin: 0;
        font-size: 12px;
        color: #94a3b8;
    }
`;

// Footer do carrinho (sempre visível)
const CartFooter = styled.div`
    flex-shrink: 0;
    border-top: 1px solid #e5e7eb;
    background: white;
`;

const CartSummary = styled.div`
    padding: 16px 20px;
    background: #f8fafc;

    @media (max-height: 800px) {
        padding: 6px 12px;
    }
`;

const SummaryRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;

    span {
        font-size: 13px;
        color: #64748b;
    }

    strong {
        font-size: 13px;
        color: #1e293b;
    }

    &.total {
        margin-top: 12px;
        padding-top: 12px;
        border-top: 2px solid #e5e7eb;

        span {
            font-size: 15px;
            font-weight: 700;
            color: #1e293b;
        }

        strong {
            font-size: 18px;
            font-weight: 800;
            color: #318CD5;
        }
    }

    @media (max-height: 800px) {
        margin-bottom: 2px;
        span { font-size: 11px; }
        strong { font-size: 11px; }
        &.total {
            margin-top: 4px;
            padding-top: 4px;
            span { font-size: 12px; }
            strong { font-size: 14px; }
        }
    }
`;

const CustomerSection = styled.div`
    padding: 16px 20px;
    border-top: 1px solid #e5e7eb;
    position: relative;

    @media (max-height: 800px) {
        padding: 6px 12px;
    }
`;

const CustomerInputs = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;

    input {
        flex: 1;
        min-width: 120px;
        padding: 8px 12px;
        border: 2px solid #e5e7eb;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 500;
        color: #1e293b;
        transition: all 0.2s ease;

        &:focus {
            outline: none;
            border-color: #318CD5;
            box-shadow: 0 0 0 3px rgba(49, 140, 213, 0.1);
        }

        &::placeholder {
            color: #94a3b8;
        }
    }

    @media (max-width: 400px) {
        flex-direction: column;

        input {
            width: 100%;
        }
    }
`;

const CustomersDropdown = styled.div`
    position: absolute;
    top: calc(100% - 10px);
    left: 20px;
    right: 20px;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
`;

const CustomerOption = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    transition: background 0.15s ease;
    border-bottom: 1px solid #f1f5f9;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #f8fafc;
    }

    .customer-phone {
        font-size: 14px;
        color: #64748b;
        font-weight: 500;
    }

    .customer-name {
        font-size: 14px;
        color: #1e293b;
        font-weight: 600;
    }
`;

const ConfigButtons = styled.div`
    padding: 8px 12px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
`;

const ConfigBtn = styled.button`
    padding: 6px 10px;
    border: 2px solid ${({ active }) => active ? '#318CD5' : '#e5e7eb'};
    border-radius: 8px;
    background: ${({ active }) => active ? '#318CD5' : 'white'};
    color: ${({ active }) => active ? 'white' : '#64748b'};
    font-size: 11px;
    font-weight: 600;
    cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s ease;
    text-transform: uppercase;
    opacity: ${({ disabled }) => disabled ? 0.5 : 1};

    &:hover:not(:disabled) {
        border-color: #318CD5;
        color: ${({ active }) => active ? 'white' : '#318CD5'};
    }
`;

const SubmitBtn = styled.button`
    width: calc(100% - 24px);
    margin: 8px 12px 12px;
    padding: 10px 20px;
    background: ${({ disabled }) => disabled ? '#94a3b8' : 'linear-gradient(135deg, #318CD5 0%, #4facfe 100%)'};
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 700;
    cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s ease;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    box-shadow: ${({ disabled }) => disabled ? 'none' : '0 4px 12px rgba(49, 140, 213, 0.3)'};

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(49, 140, 213, 0.4);
    }
`;

// const BtnSendToCartPdv = styled.button` // Não utilizado atualmente
//   display: inline-block;
//   padding: 0.75rem 1.25rem;
//   border-radius: 10rem;
//   color: #fff;
//   text-transform: uppercase;
//   font-size: 1rem;
//   letter-spacing: 0.15rem;
//   position: relative;
//   overflow: hidden;
//   z-index: 1;
//   background-color: transparent;
//   border: 2px solid #0cf;
//   cursor: pointer;
//   transition: all 0.3s;
//   animation: colorAnimation 1s infinite; /* Inicia a animação a cada 1 segundo */

//   &:after {
//     content: '';
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     background-color: #0cf;
//     border-radius: 10rem;
//     z-index: -2;
//   }

//   &:before {
//     content: '';
//     position: absolute;
//     bottom: 0;
//     left: 0;
//     width: 0%;
//     height: 100%;
//     background-color: #009e9e; /* Cor mais escura */
//     border-radius: 10rem;
//     transition: all 0.3s;
//     z-index: -1;
//     animation: expandAnimation 2s infinite;
//   }

//   /* Animação do efeito de cor */
//   @keyframes colorAnimation {
//     0%, 100% {
//       color: #fff;
//     }
//   }

//   /* Animação de expansão da cor de fundo */
//   @keyframes expandAnimation {
//     0%, 100% {
//       width: 0%;
//     }
//     50% {
//       width: 100%;
//     }
//   }
// `;

const ModalPdv = ({
    showModal,
    setShowModal,
    infoPedido,
    setInfoPedido,
    itensCarrinho,
    setItensCarrinho,
    nomeCliente,
    setNomeCliente,
    telefone,
    setTelefone,
    selectedCliente,
    setSelectedCliente,
    //formaEntrega,
    //setFormaEntrega
    savedFormaEntrega,
    setSavedFormaEntrega,
    selectedPayment,
    setSelectedPayment,
    cpfCnpjValue,
    setCpfCnpjValue,
    valueDescricao,
    setValueDescricao,
    setRefresh,
    typePedido = "delivery",
}) => {
    const { t } = useTranslation('pdv');
    const [isClosing, setIsClosing] = useState(false);
    const userParse = getStoredUser();
    const userID = userParse?._id;
    //const empresa = localStorage.getItem('empresa');
    //const empresaParse = JSON.parse(empresa);
    //const empresaObjId = empresaParse._id;
    //const idEmpresa = empresaParse.id_empresa;
    //const vinculo_empresa = empresaParse.cnpj;
    const [empresa, setEmpresa] = useState(null);
    const [idEmpresa, setIdEmpresa] = useState(null);
    const nomeEmpresaForUrl = empresa?.name.replace(/ /g, '-').toLowerCase();
    const enderecoEmpresa = empresa ? {
        bairro: empresa.bairro,
        cidade: empresa.municipio,
        estado: empresa.estado,
        numero: empresa.address_number,
        rua: empresa.logradouro
    } : null;
    // const [tipoImpressao, setTipoImpressao] = useState(""); // Não utilizado atualmente
    // const { sidebar, setSidebar } = useContext(SidebarContext); // Não utilizado atualmente
    const [categorias, setCategorias] = useState([]);
    const [itens, setItens] = useState([]);
    const [selectedCategoria, setSelectedCategoria] = useState("");
    //const [celularCliente, setCelularCliente] = useState("");

    const [clientes, setClientes] = useState([]);
    const [itensSelecionados, setItensSelecionados] = useState([]); // Estado temporário para itens selecionados
    //const [itensCarrinho, setItensCarrinho] = useState(getFromLocalStorage('itensCarrinho') || []);
    //TEMP
    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("ITENS CARRINHO:", getFromLocalStorage('itensCarrinho'));
    //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("infoPedido:", infoPedido);
    ////////
    const [editarPedido, setEditarPedido] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const containerRef = useRef(null);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [showAdicionaisModal, setShowAdicionaisModal] = useState(false);
    // const [adicionais, setAdicionais] = useState([]); // Não utilizado atualmente
    const [adicionaisCompletos, setAdicionaisCompletos] = useState([]);  // Adicione este estado
    const [quantidades, setQuantidades] = useState({});  // Adicione este estado
    const [showModalAddObsPedido, setShowModalAddObsPedido] = useState(true);
    // const [currentEditingItem, setCurrentEditingItem] = useState(null); // Não utilizado atualmente
    const [itemSelecionadoParaObs, setItemSelecionadoParaObs] = useState(null);
    const [obsItem, setObsItem] = useState("");
    const [showModalAddObsItem, setShowModalAddObsItem] = useState(true);
    const [showModalEntregaPdv, setShowModalEntregaPdv] = useState(true);
    const [formaEntrega, setFormaEntrega] = useState(null);
    const [showModalPagamentos, setShowModalPagamentos] = useState(true);
    const [formaPagamento, setFormaPagamento] = useState("Dinheiro");
    //const [selectedPayment, setSelectedPayment] = useState(null);
    const [valorEntrega, setValorEntrega] = useState(0);
    //const [savedFormaEntrega, setSavedFormaEntrega] = useState(null);
    const [showModalCpfCnpj, setShowModalCpfCnpj] = useState(true);
    const [desconto, setDesconto] = useState(infoPedido?.desconto || 0);
    const [showModalDesconto, setShowModalDesconto] = useState(false);
    //const [cpfCnpjValue, setCpfCnpjValue] = useState('');
    //const [valueDescricao, setValueDescricao] = useState('');
    // const navigate = useNavigate(); // Não utilizado atualmente

    const [loading, setLoading] = useState(true); // Estado de carregamento

    useEffect(() => {
        let isMounted = true;

        const fetchEmpresa = async () => {
            try {
                const response = await getVinculoEmpresa(userID);
                if (response.data.vinculo) {
                    const vinculo = response.data.vinculo;
                    if (isMounted) {
                        setEmpresa(vinculo);
                        setIdEmpresa(vinculo.id_empresa);
                        // ✅ CORREÇÃO V2: Chamar sem parâmetros (usa token JWT automaticamente)
                        const categoriaTemp = await getCategorias();
                        const itemTemp = await getItens();
                        if (isMounted) {
                            setCategorias(categoriaTemp.data.categorias);
                            setItens(itemTemp.data.itens);
                            setLoading(false); // Dados carregados, definir loading como falso
                            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("✅ Categorias e itens carregados:", {
                                categorias: categoriaTemp.data.categorias.length,
                                itens: itemTemp.data.itens.length
                            });
                        }
                    }
                }
            } catch (error) {
                process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao buscar dados:", error);
                if (isMounted) {
                    setLoading(false); // Em caso de erro, definir loading como falso
                }
            }
        };

        fetchEmpresa();

        return () => {
            isMounted = false;
        };
    }, [userID]);

    // Cleanup: remover backdrop órfão do react-bootstrap Modal ao desmontar
    useEffect(() => {
        return () => {
            document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
            document.body.classList.remove('modal-open');
            document.body.style.removeProperty('overflow');
            document.body.style.removeProperty('padding-right');
        };
    }, []);

    useEffect(() => {
        saveToLocalStorage('itensCarrinho', itensCarrinho);
    }, [itensCarrinho]);

    const fetchAdicionais = async (item) => {
        try {
            const response = await getAdicionaisCardapio(idEmpresa, nomeEmpresaForUrl);
            const adicionaisFromDB = response.data.adicionais;
            //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("adicionaisFromDB:",adicionaisFromDB)
            if (item.has_adicional && item.adicionais && adicionaisFromDB) {
                const adicionaisEncontrados = adicionaisFromDB.filter(adicionalDB =>
                    item.adicionais.some(adicionalItem => adicionalItem.value === adicionalDB._id)
                );
                // Tipo A: ordenar os grupos pela ordem definida no item (drag-and-drop)
                const __ordemGrupos = (item?.adicionais || []).map(a => String(a.value));
                adicionaisEncontrados.sort((a, b) => __ordemGrupos.indexOf(String(a._id)) - __ordemGrupos.indexOf(String(b._id)));

                setAdicionaisCompletos(adicionaisEncontrados);
                setQuantidades({}); // Resetar as quantidades ao abrir o modal
                setShowModalDesconto(false); // Fecha o desconto ao abrir adicionais (evita conflito de modais)
                setShowAdicionaisModal(true);
            }
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao buscar adicionais:', error);
        }
    };

    const handleCloseModal = () => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log("fechou!")
        // Fechar modal de adicionais se estiver aberto (evita backdrop órfão)
        setShowAdicionaisModal(false);
        // Inicia animação de saída
        setIsClosing(true);
        // Aguarda animação terminar antes de fechar
        setTimeout(() => {
            setIsClosing(false);
            setShowModal(!showModal);
            removeFromLocalStorage('itensCarrinho');
        }, 350); // Duração da animação slideOut
    }

    // Função de handleFinalizar para o ModalAdicionais
    const handleFinalizarAdicionais = (item, selectedAdicionais) => {
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('item', item);
        const updatedItem = {
            ...item,
            adicionais: selectedAdicionais,
            quantity: 1 // ou a quantidade desejada
        };
        updateCartItem(updatedItem);
        setShowAdicionaisModal(false);
        setQuantidades({});
        setAdicionaisCompletos([]);
    };

    /*const handleItemClick = (item) => {
        setSelectedItem(item);
        if (item.has_adicional) {
            fetchAdicionais(item);
        } else {
            incrementCount(item);
        }
    };*/
    const itemClickLockRef = useRef(false);
    const handleItemClick = (item) => {
        // Prevenir cliques duplos rápidos que causam múltiplas aberturas de modal
        if (itemClickLockRef.current) return;

        const itemExistente = itensSelecionados.find(i => i._id === item._id);
        if (itemExistente) {
            incrementCount(item);
        } else {
            setSelectedItem(item);
            if (item.has_adicional) {
                itemClickLockRef.current = true;
                fetchAdicionais(item).finally(() => {
                    // Liberar lock após modal abrir (com delay para evitar double-click)
                    setTimeout(() => { itemClickLockRef.current = false; }, 500);
                });
            } else {
                incrementCount(item);
            }
        }
    };

    const updateCartItem = (updatedItem) => {
        setItensSelecionados(prevItens => {
            const index = prevItens.findIndex(item => item._id === updatedItem._id);
            if (index !== -1) {
                const newItensSelecionados = [...prevItens];
                newItensSelecionados[index] = updatedItem;
                return newItensSelecionados;
            }
            return [...prevItens, updatedItem];
        });
    };

    // Gera uma chave leve para comparar se dois itens com adicionais são "iguais"
    // Evita JSON.stringify de objetos complexos a cada comparação
    const gerarChaveAdicionais = (adicionais) => {
        if (!adicionais || !Array.isArray(adicionais) || adicionais.length === 0) return '';
        return adicionais.map(grupo =>
            `${grupo.grupoId}:${(grupo.adicionais || []).filter(a => a.quantity > 0).map(a => `${a.adicionalId}x${a.quantity}`).join(',')}`
        ).join('|');
    };

    const handleEnviarParaCarrinho = () => {
        if (itensSelecionados.length === 0) {
            toast(t('editOrder.noItemsSelected'), { autoClose: 2000, type: "warning" });
            return;
        }

        const updatedCarrinho = [...itensCarrinho];

        // Pre-calcular chaves do carrinho existente (uma vez, não a cada item)
        const carrinhoChaves = updatedCarrinho.map(i => `${i._id}_${gerarChaveAdicionais(i.adicionais)}`);

        itensSelecionados.forEach(selecionado => {
            const chaveSelecionado = `${selecionado._id}_${gerarChaveAdicionais(selecionado.adicionais)}`;
            const existingItemIndex = carrinhoChaves.indexOf(chaveSelecionado);

            const adicionaisAtualizados = Array.isArray(selecionado.adicionais) ? selecionado.adicionais.map(grupo => ({
                ...grupo,
                calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                calcular_media: grupo.calcular_media ?? false
            })) : [];

            const itemAtualizado = {
                ...selecionado,
                adicionais: adicionaisAtualizados,
            };

            if (existingItemIndex > -1) {
                updatedCarrinho[existingItemIndex] = {
                    ...updatedCarrinho[existingItemIndex],
                    quantity: updatedCarrinho[existingItemIndex].quantity + selecionado.quantity,
                    adicionais: updatedCarrinho[existingItemIndex].adicionais.map((grupo, groupIndex) => ({
                        ...grupo,
                        adicionais: grupo.adicionais.map((adicional, adicionalIndex) => ({
                            ...adicional,
                            quantity: adicional.quantity + (selecionado.adicionais[groupIndex]?.adicionais[adicionalIndex]?.quantity || 0)
                        }))
                    }))
                };
                // Atualizar a chave para refletir a mudança
                carrinhoChaves[existingItemIndex] = `${updatedCarrinho[existingItemIndex]._id}_${gerarChaveAdicionais(updatedCarrinho[existingItemIndex].adicionais)}`;
            } else {
                updatedCarrinho.push(itemAtualizado);
                carrinhoChaves.push(chaveSelecionado);
            }
        });

        toast(t('editOrder.itemsSentToCart'), { autoClose: 1000, type: "success" });
        setItensCarrinho(updatedCarrinho);
        setItensSelecionados([]);
        // Nota: useEffect em [itensCarrinho] já salva no localStorage, não precisa duplicar
    };


    const handleChange = (e, item) => {
        const newQuantity = parseInt(e.target.value, 10);
        if (isNaN(newQuantity) || newQuantity < 0) return;
        const index = itensSelecionados.findIndex(i => i._id === item._id);
        if (index !== -1) {
            const newItensSelecionados = [...itensSelecionados];
            newItensSelecionados[index].quantity = newQuantity;
            setItensSelecionados(newItensSelecionados);
        }
    };

    const handleAddObsPedido = () => {
        //toast("Observação adicionada", { autoClose: 2000, type: "success" });
        setShowModalAddObsPedido(!showModalAddObsPedido);
    }

    const handleAddObsItem = (item, cartIndex) => {
        setItemSelecionadoParaObs({ ...item, _cartIndex: cartIndex });
        setObsItem(item.obs_item || "");
        setShowModalAddObsItem(!showModalAddObsItem);
    };

    const handleSaveObsItem = () => {
        const updatedCarrinho = itensCarrinho?.map((prod, idx) => {
            if (idx === itemSelecionadoParaObs._cartIndex) {
                return { ...prod, obs_item: obsItem };
            }
            return prod;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
        setShowModalAddObsItem(false);
        toast(t('editOrder.obsAdded'), { autoClose: 2000, type: "success" });
    };

    const handleRemoveItem = (item, cartIndex) => {
        const updatedCarrinho = itensCarrinho.filter((_, idx) => idx !== cartIndex);
        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
        toast(t('editOrder.itemRemoved'), { autoClose: 1000, type: "success" });
    };



    const normalizePhoneNumber = (phone) => {
        return phone.replace(/[^\d]/g, ''); // Remove todos os caracteres não numéricos
    };

    const fetchClientes = async (inputValue, searchType = 'phone') => {
        try {
            let response;
            if (searchType === 'phone') {
                response = await getCliente(idEmpresa, normalizePhoneNumber(inputValue));
            } else {
                // Busca por nome
                response = await getClienteByName(idEmpresa, inputValue);
            }
            if (response.status === 200) {
                const clientesData = response.data.clientes.map(cliente => ({
                    ...cliente
                }));
                setClientes(clientesData);
                return clientesData;
            }
            setClientes([]);
        } catch (error) {
            process.env.REACT_APP_ISDEVELOP === 'true' && console.error("Erro ao buscar clientes:", error);
            setClientes([]);
            return [];
        }
    };

    const handleNomeChange = async (event) => {
        const inputValue = event.target.value;
        setNomeCliente(inputValue);

        // Busca por nome se tiver pelo menos 2 caracteres após trim
        const normalizedName = inputValue.trim();
        if (normalizedName.length >= 2) {
            await fetchClientes(inputValue, 'name');
        } else {
            setClientes([]);
        }

        // Se não há cliente selecionado ou o nome mudou, atualiza a seleção
        if (!selectedCliente || selectedCliente.nome !== inputValue) {
            setSelectedCliente({
                ...selectedCliente,
                nome: inputValue
            });
        }
    };

    const handleTelefoneChange = async (val) => {
        setTelefone(val || '');

        // Validar se tem pelo menos 3 dígitos após normalização
        const digits = localDigitsFromE164(val);
        if (digits.length >= 3) {
            await fetchClientes(digits, 'phone');
        } else {
            setClientes([]);
        }
        setSelectedCliente(null);
        setNomeCliente("");
    };

    const handleClienteClick = (cliente) => {
        //////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("ENTROU AQUI? cliente>>", cliente);
        setSelectedCliente(cliente);
        setNomeCliente(cliente.nome);
        setTelefone(toE164(cliente.telefone_completo || cliente.telefone));
        setClientes([]); // Limpa a lista após seleção
    };

    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setClientes([]); // Limpa a lista se clicar fora
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (telefone === "") {
            setSelectedCliente(null);
        }
    }, [telefone, setSelectedCliente]); // Removido selectedCliente das deps - causava re-render loop

    const incrementCount = (item) => {
        const index = itensSelecionados.findIndex(i => i._id === item._id);
        if (index !== -1) {
            setItensSelecionados(prev => prev.map((i, idx) =>
                idx === index ? { ...i, quantity: i.quantity + 1 } : i
            ));
        } else {
            setItensSelecionados(prev => [...prev, { ...item, quantity: 1 }]);
        }
    };

    const decrementCount = (item) => {
        const index = itensSelecionados.findIndex(i => i._id === item._id);
        if (index !== -1) {
            const newItensSelecionados = [...itensSelecionados];
            if (newItensSelecionados[index].quantity > 1) {
                newItensSelecionados[index].quantity -= 1;

                // Diminuir os adicionais
                if (newItensSelecionados[index].adicionais) {
                    newItensSelecionados[index].adicionais.forEach(grupo => {
                        grupo.adicionais.forEach(adicional => {
                            adicional.quantity -= adicional.quantity / (newItensSelecionados[index].quantity + 1);
                        });
                    });
                }
            } else {
                newItensSelecionados.splice(index, 1);
            }
            setItensSelecionados(newItensSelecionados);
        }
    };

    // Função para calcular soma de adicionais de um item (extraída para reusar)
    const calcularAdicionaisSum = (adicionais) => {
        if (!Array.isArray(adicionais)) return 0;
        return adicionais.reduce((acc, grupo) => {
            if (grupo.calcular_maior_valor) {
                const prices = Array.isArray(grupo.adicionais)
                    ? grupo.adicionais.map(a => a.price)
                    : [];
                return acc + (prices.length > 0 ? Math.max(...prices) : 0);
            } else if (grupo.calcular_media) {
                const selecionados = Array.isArray(grupo.adicionais)
                    ? grupo.adicionais.filter(a => a.quantity > 0)
                    : [];
                if (selecionados.length > 0) {
                    const soma = selecionados.reduce((s, a) => s + (a.price * a.quantity), 0);
                    return acc + (soma / selecionados.length);
                }
                return acc;
            } else {
                return acc + (Array.isArray(grupo.adicionais)
                    ? grupo.adicionais.reduce((s, a) => s + (a.price * a.quantity), 0)
                    : 0);
            }
        }, 0);
    };

    // Memoizado: só recalcula quando itensCarrinho ou typePedido mudam
    const subTotal = useMemo(() => {
        if (!Array.isArray(itensCarrinho)) return 0;
        return itensCarrinho.reduce((sum, item) => {
            const adicionaisSum = calcularAdicionaisSum(item.adicionais);
            const price = typePedido === 'mesa' ? (item.price_salao || item.price) : item.price;
            return sum + (item.quantity * price) + (adicionaisSum * item.quantity);
        }, 0);
    }, [itensCarrinho, typePedido]);

    const safeSubTotal = isNaN(Number(subTotal)) ? 0 : Number(subTotal);
    const safeValorEntrega = savedFormaEntrega && !isNaN(Number(savedFormaEntrega.valorEntrega))
        ? Number(savedFormaEntrega.valorEntrega)
        : 0;

    // subTotal e valorTotalMesa usam o mesmo cálculo (mesma fórmula, mesma referência a price)
    const valorTotalMesa = subTotal;

    // Reset discount if it exceeds subtotal (e.g. items removed from cart)
    const effectiveSubTotal = typePedido !== 'mesa' ? safeSubTotal : valorTotalMesa;
    useEffect(() => {
        if (desconto > 0 && desconto > effectiveSubTotal) {
            setDesconto(0);
        }
    }, [effectiveSubTotal, desconto]);

    let valorTotal = typePedido !== 'mesa' ? safeSubTotal + safeValorEntrega - desconto : valorTotalMesa - desconto;

    const renderAdicionais = (cartIndex, adicionais) => {
        if (!adicionais || !Array.isArray(adicionais)) return null;
        const cartItem = itensCarrinho[cartIndex];
        const itemQty = cartItem?.quantity || 1;
        return adicionais.map(grupo => (
            <div key={grupo.grupoId} className="adicionais-group">
                <span style={{ fontWeight: 'bold' }}>{grupo.grupoTitle}</span>
                {Array.isArray(grupo.adicionais) && grupo.adicionais.map(adicional => (
                    <div key={adicional.adicionalId} className="adicional-item">
                        <span className="titleAdicionalCart">{adicional.title} ({grupo.calcular_maior_valor || grupo.calcular_media
                            ? (adicional.quantity * itemQty) > grupo.adicionais.length
                                ? `${grupo.adicionais.length}/${grupo.adicionais.length}`
                                : `${adicional.quantity * itemQty}/${grupo.adicionais.length}`
                            : `x${adicional.quantity * itemQty}`})</span>
                        <div className="line" />
                        <span style={{ minWidth: 60 }}>
                            {grupo.calcular_media
                                ? formatPriceWithSymbol(
                                    (grupo.adicionais.reduce((acc, subAdicional) => acc + (subAdicional.price * subAdicional.quantity), 0) /
                                    grupo.adicionais.reduce((acc, subAdicional) => acc + subAdicional.quantity, 0) / grupo.adicionais.length) * itemQty
                                )
                                : grupo.calcular_maior_valor
                                    ? adicional.price === Math.max(...grupo.adicionais.map(subAdicional => subAdicional.price))
                                        ? formatPriceWithSymbol(Math.max(...grupo.adicionais.map(subAdicional => subAdicional.price)) * itemQty)
                                        : formatPriceWithSymbol(0)
                                    : formatPriceWithSymbol(adicional.price * adicional.quantity * itemQty)
                            }
                        </span>
                    </div>
                ))}
            </div>
        ));
    };


    const incrementAdicionalCount = (cartIndex, grupoId, adicionalId) => {
        const updatedCarrinho = itensCarrinho?.map((i, idx) => {
            if (idx === cartIndex) {
                return {
                    ...i,
                    adicionais: i.adicionais.map(grupo => {
                        if (grupo.grupoId === grupoId) {
                            return {
                                ...grupo,
                                calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                                calcular_media: grupo.calcular_media ?? false,
                                adicionais: grupo.adicionais.map(adicional => {
                                    if (adicional.adicionalId === adicionalId) {
                                        return {
                                            ...adicional,
                                            quantity: adicional.quantity + 1
                                        };
                                    }
                                    return adicional;
                                })
                            };
                        }
                        return grupo;
                    })
                };
            }
            return i;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    const decrementAdicionalCount = (cartIndex, grupoId, adicionalId) => {
        const updatedCarrinho = itensCarrinho?.map((i, idx) => {
            if (idx === cartIndex) {
                return {
                    ...i,
                    adicionais: i.adicionais.map(grupo => {
                        if (grupo.grupoId === grupoId) {
                            return {
                                ...grupo,
                                calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                                calcular_media: grupo.calcular_media ?? false,
                                adicionais: grupo.adicionais.map(adicional => {
                                    if (adicional.adicionalId === adicionalId && adicional.quantity > 1) {
                                        return {
                                            ...adicional,
                                            quantity: adicional.quantity - 1
                                        };
                                    }
                                    return adicional;
                                })
                            };
                        }
                        return grupo;
                    })
                };
            }
            return i;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    // const subTotalAdicionais = (adicionais) => { // Função não utilizada atualmente
    //     if (!adicionais || !Array.isArray(adicionais)) return null;
    //     return adicionais.map(grupo => (
    //         grupo.adicionais.map(adicional => (
    //             (adicional.price * adicional.quantity).toFixed(2).replace('.', ',')
    //         ))

    //     ));
    // };


    const handleScrollOnClick = (mongodbId) => {
        const element = document.getElementById(mongodbId);
        if (element) {
            setSelectedCategoria(mongodbId);
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    const handleEditaPedido = () => {
        setEditarPedido(true);
    };

    const handleConcluirEdicao = () => {
        //toast('Edição concluída', { autoClose: 2000, type: "success" });
        saveToLocalStorage('itensCarrinho', itensCarrinho);
        setEditarPedido(false);
    };

    const handleChangeLocalStorage = (e, cartIndex) => {
        const newQuantity = parseInt(e.target.value, 10);
        if (isNaN(newQuantity) || newQuantity < 0) return;

        const updatedCarrinho = itensCarrinho?.map((i, idx) => {
            if (idx === cartIndex) {
                return { ...i, quantity: newQuantity };
            }
            return i;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    const incrementCountLocalStorage = (cartIndex) => {
        const updatedCarrinho = itensCarrinho?.map((i, idx) => {
            if (idx === cartIndex) {
                return {
                    ...i,
                    quantity: i.quantity + 1,
                    adicionais: i.adicionais.map(grupo => ({
                        ...grupo,
                        calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                        calcular_media: grupo.calcular_media ?? false,
                        adicionais: grupo.adicionais.map(adicional => ({
                            ...adicional,
                            quantity: adicional.quantity
                        }))
                    }))
                };
            }
            return i;
        });

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    const decrementCountLocalStorage = (cartIndex) => {
        const updatedCarrinho = itensCarrinho.reduce((acc, i, idx) => {
            if (idx === cartIndex) {
                if (i.quantity > 1) {
                    acc.push({
                        ...i,
                        quantity: i.quantity - 1,
                        adicionais: i.adicionais.map(grupo => ({
                            ...grupo,
                            calcular_maior_valor: grupo.calcular_maior_valor ?? false,
                            calcular_media: grupo.calcular_media ?? false,
                            adicionais: grupo.adicionais.map(adicional => ({
                                ...adicional,
                                quantity: adicional.quantity
                            }))
                        }))
                    });
                }
                // Se a quantidade for 1, não adiciona de volta para `acc`, efetivamente removendo-o
            } else {
                acc.push(i);
            }
            return acc;
        }, []);

        setItensCarrinho(updatedCarrinho);
        saveToLocalStorage('itensCarrinho', updatedCarrinho);
    };

    useEffect(() => {
        if (itensCarrinho.length === 0) {
            setEditarPedido(false);
        }
    }, [itensCarrinho]);

    const handleDeletePedido = () => {
        setItensCarrinho([]);
        setEditarPedido(false);
        setValueDescricao('');
        toast(t('messages.itemsDeleted'), { autoClose: 2500, type: "success" });
    };

    const handleClickEntrega = async () => {
        setShowModalEntregaPdv(!showModalEntregaPdv)
        try {
            const response = await registerClienteFromCardapio(idEmpresa, nomeCliente, fromE164(telefone));
            process.env.REACT_APP_ISDEVELOP === 'true' && console.log("ENTROU AQUI? OQ CHEGOU NO RESPONSE?", response);
            if (response.status === 201 || response.status === 200) {
                let cliente = response.data.cliente;
                ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("response:", cliente);
                setSelectedCliente(cliente)
            }
        } catch (error) {
            ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("error:",error);
        }

    }

    const handleSubmitAPI = () => {
        const objIdPedido = infoPedido._id;
        const itens = itensCarrinho?.map(item => {
            const { title, price, price_salao, quantity, adicionais, obs_item } = item;
            const basePrice = typePedido === 'mesa' ? price_salao || price || 0 : price;
            const valor = basePrice;
            return { nomeItem: title, valor, quantidade: quantity, grupo_adicionais: adicionais, obs_item };
        });
        if (itens.length === 0) {
            toast(t('editOrder.noItemsWarning'), { autoClose: 3000, type: "warning" });
            return;
        }
        ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("Forma de pagamento salva:::", selectedPayment);
        const celular_cliente = fromE164(telefone);//selectedCliente.telefone;
        const nome_cliente = nomeCliente;//selectedCliente.nome;
        const tipo_pagamento = selectedPayment?.paymentType;
        const entrega = {
            tipo_entrega: savedFormaEntrega?.formaEntrega,
            endereco: savedFormaEntrega?.selectedAddress ? savedFormaEntrega?.selectedAddress : enderecoEmpresa,
            valor: savedFormaEntrega?.valorEntrega
        };
        const descontoValue = desconto;
        const cpf_cnpj = cpfCnpjValue;
        const valor_troco = selectedPayment?.paymentType === "Dinheiro" ? selectedPayment.valorTroco : 0;
        const valor_total = valorTotal;
        const descricao = valueDescricao;
        /*process.env.REACT_APP_ISDEVELOP === 'true' && console.log({
            createdBy,
            idEmpresa,
            itens,
            celular_cliente,
            nome_cliente,
            tipo_pagamento,
            entrega,          
            desconto,
            cpf_cnpj,
            valor_troco,
            valor_total,
            descricao
        })*/

        if(typePedido !== 'mesa') {
            // ✅ CORRIGIDO: Removido idEmpresa - V2 usa req.context automaticamente
            updatePedidoFromPdv(objIdPedido, itens, celular_cliente, nome_cliente, tipo_pagamento, entrega, descontoValue, cpf_cnpj, valor_troco, valor_total, descricao, infoPedido.external_id).then(cast => {
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("AQUI DEU BOM, CRIOU PEDIDO:::",cast)
                // ✅ CORRIGIDO: Backend V2 retorna status 200 para atualização
                if (cast.status === 200) {
                    if (cast.data.pedido) {
                        setInfoPedido(cast.data.pedido);
                        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("cast.data::::",cast.data)
                    }
                    localStorage.removeItem('itensCarrinho');
                    setValueDescricao('');
                    setItensCarrinho([]);
                    setSelectedPayment(null);
                    setCpfCnpjValue('');
                    setSelectedCliente(null);
                    setTelefone('');
                    setClientes([]);
                    setValorEntrega(0);
                    setSavedFormaEntrega(null);
                    setNomeCliente('');
                    handleCloseModal();
                    setRefresh(true);
                    toast(cast.data.msg, { autoClose: 5000, type: "success" });
                }
                else {
                    toast(cast.data.msg, { autoClose: 5000, type: "error" });
                }
    
            }).catch(err => {
                ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Oh noooo!!');
                const msg = err.response.data.msg;
                //////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("MENSAGEM", msg)
                toast(msg, { autoClose: 5000, type: "error" });
            });

        } else {
            

            // ✅ CORRIGIDO: Removido idEmpresa e ajustados parâmetros para função V2
            updatePedidoFromMesas(objIdPedido, itens, celular_cliente, nome_cliente, tipo_pagamento, entrega, descontoValue, cpf_cnpj, valor_troco, valorTotal, descricao, infoPedido.mesa_id, infoPedido.mesa_numero).then(cast => {
                //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("AQUI DEU BOM, CRIOU PEDIDO:::",cast)
                // ✅ CORRIGIDO: Backend V2 retorna status 200 para atualização
                if (cast.status === 200) {
                    if (cast.data.pedido) {
                        setInfoPedido(cast.data.pedido);
                        //process.env.REACT_APP_ISDEVELOP === 'true' && console.log("cast.data::::",cast.data)
                    }
                    localStorage.removeItem('itensCarrinho');
                    setValueDescricao('');
                    setItensCarrinho([]);
                    setSelectedPayment(null);
                    setCpfCnpjValue('');
                    setSelectedCliente(null);
                    setTelefone('');
                    setClientes([]);
                    setValorEntrega(0);
                    setSavedFormaEntrega(null);
                    setNomeCliente('');
                    handleCloseModal();
                    setRefresh(true);
                    toast(cast.data.msg, { autoClose: 5000, type: "success" });
                }
                else {
                    toast(cast.data.msg, { autoClose: 5000, type: "error" });
                }
    
            }).catch(err => {
                ////process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Oh noooo!!');
                const msg = err.response.data.msg;
                //////process.env.REACT_APP_ISDEVELOP === 'true' && console.log("MENSAGEM", msg)
                toast(msg, { autoClose: 5000, type: "error" });
            });

        }
    };

    return (
        <PermissionGate permissions={['default']}>
            <ModalAddObsPedido showModalAddObsPedido={showModalAddObsPedido}
                setShowModalAddObsPedido={setShowModalAddObsPedido}
                itensCarrinho={itensCarrinho}
                setItensCarrinho={setItensCarrinho}
                valueDescricao={valueDescricao}
                setValueDescricao={setValueDescricao}
            />
            <ModalAddObsItem showModalAddObsItem={showModalAddObsItem}
                setShowModalAddObsItem={setShowModalAddObsItem}
                obsItem={obsItem}
                setObsItem={setObsItem}
                handleSaveObsItem={handleSaveObsItem}
            />
            <ModalEntregaPdv showModalEntregaPdv={showModalEntregaPdv}
                setShowModalEntregaPdv={setShowModalEntregaPdv}
                formaEntrega={formaEntrega}
                setFormaEntrega={setFormaEntrega}
                selectedCliente={selectedCliente}
                setSelectedCliente={setSelectedCliente}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                empresa={empresa}
                valorEntrega={valorEntrega}
                setValorEntrega={setValorEntrega}
                setSavedFormaEntrega={setSavedFormaEntrega}
            />
            <ModalPagamentos showModalPagamentos={showModalPagamentos}
                setShowModalPagamentos={setShowModalPagamentos}
                formaPagamento={formaPagamento}
                setFormaPagamento={setFormaPagamento}
                selectedPayment={selectedPayment}
                setSelectedPayment={setSelectedPayment}
                selectedCliente={selectedCliente}
                setSelectedCliente={setSelectedCliente}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                empresa={empresa}
                subTotal={subTotal}
                valorTotal={valorTotal}
                savedFormaEntrega={savedFormaEntrega}
            />
            <ModalCpfCnpj showModalCpfCnpj={showModalCpfCnpj}
                setShowModalCpfCnpj={setShowModalCpfCnpj}
                cpfCnpjValue={cpfCnpjValue}
                setCpfCnpjValue={setCpfCnpjValue}
            />
            <ModalWrapper showModal={showModal} isClosing={isClosing}>
                {/* Botão de Recolher com seta >> */}
                <CollapseButton
                    onClick={handleCloseModal}
                    title={t('editOrder.collapse')}
                    aria-label={t('editOrder.collapse')}
                >
                    <HiChevronDoubleRight />
                </CollapseButton>

                <Teste>
                    {loading && <Loading type={"spinningBubbles"} color="#318CD5" style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 100 }} />}

                    <ModernLayout>
                        {/* Seção do Menu (Esquerda) */}
                        <MenuSection>
                            <MenuHeader>
                                <HeaderTitle>
                                    <h2>
                                        <MdFastfood style={{ color: '#318CD5' }} />
                                        {t('editOrder.title')}
                                    </h2>
                                    <p>{t('editOrder.subtitle')}</p>
                                </HeaderTitle>
                                <SendToCartBtn onClick={handleEnviarParaCarrinho}>
                                    <MdShoppingCartCheckout />
                                    {t('cart.sendToCart')}
                                </SendToCartBtn>
                            </MenuHeader>

                            <MenuContent>
                                <CategoriesSidebar>
                                    <h3>{t('categories.title')}</h3>
                                    <CategoriesList>
                                        {categorias.filter(cats => itens.some(item => item.category_item_id === cats._id))
                                            .map(c => (
                                                <CategoryBtn
                                                    key={c._id}
                                                    active={c._id === selectedCategoria}
                                                    onClick={() => handleScrollOnClick(c._id)}
                                                >
                                                    {c.title}
                                                </CategoryBtn>
                                            ))}
                                    </CategoriesList>
                                </CategoriesSidebar>

                                <ItemsContainer>
                                    {categorias.filter(category => itens.some(item => item.category_item_id === category._id))
                                        .map(category => (
                                            <CategorySection key={category._id}>
                                                <CategoryHeader id={category._id}>
                                                    <h4>{category.title}</h4>
                                                </CategoryHeader>
                                                <ItemsGrid>
                                                    {itens.filter(item => item.category_item_id === category._id).map((produtos) => {
                                                        const itemSelecionado = itensSelecionados.find(i => i._id === produtos._id);
                                                        return (
                                                            <ItemCard
                                                                key={produtos._id}
                                                                selected={!!itemSelecionado}
                                                                onClick={() => handleItemClick(produtos)}
                                                            >
                                                                <ItemImage>
                                                                    <SafeImage
                                                                        src={produtos.image}
                                                                        alt={produtos.title}
                                                                        fallback={<MdFastfood />}
                                                                    />
                                                                </ItemImage>
                                                                <ItemInfo>
                                                                    <h5>{produtos.title}</h5>
                                                                    <div className="price">
                                                                        {formatPriceWithSymbol(typePedido !== 'mesa' ? produtos.price : produtos.price_salao || produtos.price)}
                                                                    </div>
                                                                    {itemSelecionado && (
                                                                        <ItemQuantity>
                                                                            <button onClick={(e) => { e.stopPropagation(); decrementCount(produtos); }}>-</button>
                                                                            <input
                                                                                type='number'
                                                                                onChange={(e) => handleChange(e, produtos)}
                                                                                value={itemSelecionado.quantity || 0}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            />
                                                                            <button onClick={(e) => { e.stopPropagation(); incrementCount(produtos); }}>+</button>
                                                                        </ItemQuantity>
                                                                    )}
                                                                </ItemInfo>
                                                            </ItemCard>
                                                        );
                                                    })}
                                                </ItemsGrid>
                                            </CategorySection>
                                        ))}
                                </ItemsContainer>
                            </MenuContent>
                        </MenuSection>

                        {/* Seção do Carrinho (Direita) */}
                        <CartSection>
                            <CartHeader>
                                <CartTitle>
                                    <h3>{t('cart.title')}</h3>
                                </CartTitle>
                                <CartActions>
                                    <ActionBtn onClick={() => handleAddObsPedido()}>
                                        {t('cart.observation')}
                                    </ActionBtn>
                                    {editarPedido ?
                                        <ActionBtn variant="primary" active onClick={handleConcluirEdicao}>
                                            {t('editOrder.exit')}
                                        </ActionBtn>
                                        :
                                        <ActionBtn onClick={handleEditaPedido}>{t('cart.edit')}</ActionBtn>
                                    }
                                    <ActionBtn variant="danger" onClick={handleDeletePedido}>{t('cart.remove')}</ActionBtn>
                                </CartActions>
                            </CartHeader>

                            <CartItems>
                                {itensCarrinho?.length === 0 ? (
                                    <EmptyCart>
                                        <MdShoppingCartCheckout />
                                        <h4>{t('cart.empty')}</h4>
                                        <p>{t('cart.emptyMessageFull')}</p>
                                    </EmptyCart>
                                ) : (
                                    <div style={{ padding: '12px' }}>
                                        {Array.isArray(itensCarrinho) && itensCarrinho.map((produtos, i) => (
                                            <div key={i} className="cart-item" style={{ marginBottom: '6px', padding: '5px 6px', background: '#f8fafc', borderRadius: '6px', border: '1px solid #e5e7eb' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <div style={{ flex: 1, display: 'flex', alignItems: 'baseline', gap: '6px', minWidth: 0 }}>
                                                        <div style={{ fontSize: '12px', fontWeight: '600', color: '#1e293b', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{produtos.title}</div>
                                                        <div style={{ fontSize: '11px', fontWeight: '700', color: '#318CD5', whiteSpace: 'nowrap' }}>
                                                            {formatPriceWithSymbol(produtos.quantity * (typePedido !== 'mesa' ? produtos.price : produtos.price_salao || produtos.price))}
                                                        </div>
                                                    </div>
                                                    {editarPedido ? (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0', background: 'white', borderRadius: '4px', border: '1px solid #e5e7eb', marginLeft: '6px' }}>
                                                            <button style={{ width: '22px', height: '22px', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '13px' }} onClick={() => decrementCountLocalStorage(i)}>-</button>
                                                            <input style={{ width: '32px', height: '22px', border: 'none', borderLeft: '1px solid #e5e7eb', borderRight: '1px solid #e5e7eb', textAlign: 'center', fontSize: '11px', fontWeight: '600' }} type='number' onChange={(e) => handleChangeLocalStorage(e, i)} value={produtos.quantity || 0} />
                                                            <button style={{ width: '22px', height: '22px', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: '13px' }} onClick={() => incrementCountLocalStorage(i)}>+</button>
                                                        </div>
                                                    ) : (
                                                        <div style={{ background: '#318CD5', color: 'white', padding: '2px 6px', borderRadius: '4px', fontSize: '11px', fontWeight: '600', marginLeft: '6px' }}>{produtos.quantity}x</div>
                                                    )}
                                                </div>
                                                {renderAdicionais(i, produtos.adicionais)}
                                                {produtos.obs_item && (
                                                    <div style={{ background: 'rgba(245, 158, 11, 0.1)', border: '1px solid rgba(245, 158, 11, 0.2)', borderRadius: '4px', padding: '3px 6px', marginTop: '3px', fontSize: '10px' }}>
                                                        <span style={{ fontWeight: '600', color: '#f59e0b' }}>{t('editOrder.itemObservation')}</span> {produtos.obs_item}
                                                    </div>
                                                )}
                                                <div className="item-actions">
                                                    <button className="item-action-btn observation" onClick={() => handleAddObsItem(produtos, i)}>{t('editOrder.addObservation')}</button>
                                                    <button className="item-action-btn remove" onClick={() => handleRemoveItem(produtos, i)}>{t('editOrder.deleteItem')}</button>
                                                </div>
                                            </div>
                                        ))}
                                        {valueDescricao !== '' && (
                                            <div style={{ background: 'rgba(59, 130, 246, 0.1)', border: '1px solid rgba(59, 130, 246, 0.2)', borderRadius: '8px', padding: '10px', marginTop: '10px' }}>
                                                <span style={{ fontSize: '11px', fontWeight: '600', color: '#3b82f6' }}>{t('editOrder.orderObservation')}</span>
                                                <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#374151' }}>{valueDescricao}</p>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </CartItems>

                            <CartFooter>
                                <CartSummary>
                                    <SummaryRow>
                                        <span>{t('cart.subtotal')}</span>
                                        <strong>{formatPriceWithSymbol(subTotal)}</strong>
                                    </SummaryRow>
                                    <SummaryRow>
                                        <span>{t('cart.discount')}</span>
                                        <strong style={desconto > 0 ? { color: '#ef4444' } : {}}>
                                            {desconto > 0 ? `-${formatPriceWithSymbol(desconto)}` : formatPriceWithSymbol(0)}
                                        </strong>
                                    </SummaryRow>
                                    <SummaryRow>
                                        <span>
                                            {t('delivery.title')}
                                            {savedFormaEntrega?.formaEntrega === "Retirada" && <small style={{ marginLeft: '6px', color: '#318CD5', fontWeight: '600' }}>- {t('editOrder.pickupAtStore')}</small>}
                                            {savedFormaEntrega?.formaEntrega === "Entrega" && <small style={{ marginLeft: '6px', color: '#318CD5', fontWeight: '600' }}>- {t('delivery.delivery')}</small>}
                                        </span>
                                        <strong>{savedFormaEntrega?.formaEntrega === "Entrega" ? formatPriceWithSymbol(savedFormaEntrega.valorEntrega) : t('delivery.free')}</strong>
                                    </SummaryRow>
                                    <SummaryRow className="total">
                                        <span>{t('cart.total')}</span>
                                        <strong>{formatPriceWithSymbol(valorTotal)}</strong>
                                    </SummaryRow>
                                </CartSummary>

                                <CustomerSection ref={containerRef}>
                                    <div style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', marginBottom: '10px' }}>{t('customer.title')}</div>
                                    <CustomerInputs>
                                        <PhoneInput
                                            onChange={handleTelefoneChange}
                                            value={telefone}
                                            placeholder={t('search.customerPhone')}
                                            autoComplete="off"
                                        />
                                        <input
                                            type="text"
                                            value={nomeCliente}
                                            onChange={handleNomeChange}
                                            placeholder={t('search.customerName')}
                                            autoComplete="off"
                                        />
                                    </CustomerInputs>
                                    {clientes.length > 0 && (
                                        <CustomersDropdown>
                                            {clientes.map(cliente => (
                                                <CustomerOption
                                                    key={cliente._id}
                                                    onMouseDown={() => handleClienteClick(cliente)}
                                                >
                                                    <span className="customer-phone">{formatPhoneDisplay(cliente.telefone_completo || cliente.telefone)}</span>
                                                    <span className="customer-name">{cliente.nome}</span>
                                                </CustomerOption>
                                            ))}
                                        </CustomersDropdown>
                                    )}
                                </CustomerSection>

                                {typePedido !== "mesa" && (
                                    <ConfigButtons>
                                        <ConfigBtn
                                            active={!!savedFormaEntrega}
                                            disabled={!selectedCliente || selectedCliente?.nome === ""}
                                            onClick={() => handleClickEntrega()}
                                        >
                                            {t('delivery.title')}
                                        </ConfigBtn>
                                        <ConfigBtn
                                            active={cpfCnpjValue !== ""}
                                            disabled={!selectedCliente || !savedFormaEntrega}
                                            onClick={() => setShowModalCpfCnpj(!showModalCpfCnpj)}
                                        >
                                            CPF/CNPJ
                                        </ConfigBtn>
                                        <ConfigBtn
                                            active={!!selectedPayment}
                                            disabled={!selectedCliente || !savedFormaEntrega}
                                            onClick={() => setShowModalPagamentos(!showModalPagamentos)}
                                        >
                                            {t('payment.title')}
                                        </ConfigBtn>
                                        <ConfigBtn
                                            active={desconto > 0}
                                            disabled={itensCarrinho.length === 0}
                                            onClick={() => {
                                                // Fecha o modal de adicionais antes de abrir o desconto
                                                // para que nunca fiquem sobrepostos.
                                                setShowAdicionaisModal(false);
                                                setSelectedItem(null);
                                                setShowModalDesconto(true);
                                            }}
                                        >
                                            {t('cart.discount')}
                                        </ConfigBtn>
                                    </ConfigButtons>
                                )}

                                <SubmitBtn
                                    onClick={handleSubmitAPI}
                                    disabled={typePedido === "mesa" ? false : !selectedCliente || !savedFormaEntrega || !selectedPayment}
                                >
                                    {t('editOrder.update')}
                                </SubmitBtn>
                            </CartFooter>
                        </CartSection>
                    </ModernLayout>
                </Teste>

                <ModalAdicionais
                    show={showAdicionaisModal && !!selectedItem}
                    onClose={() => setShowAdicionaisModal(false)}
                    item={selectedItem || {}}
                    idEmpresa={idEmpresa}
                    nomeEmpresaForUrl={nomeEmpresaForUrl}
                    quantidades={quantidades}
                    setQuantidades={setQuantidades}
                    adicionaisCompletos={adicionaisCompletos}
                    setAdicionaisCompletos={setAdicionaisCompletos}
                    handleFinalizarAdicionais={handleFinalizarAdicionais}
                />
                <ModalDesconto
                    isOpen={showModalDesconto}
                    onClose={() => setShowModalDesconto(false)}
                    onApply={(value) => setDesconto(value)}
                    subtotal={subTotal}
                    currentDiscount={desconto}
                />
            </ModalWrapper>
        </PermissionGate>
    );
};

export default ModalPdv;
